export const LIST_MODE = 'List';
export const MAP_MODE = 'Map';
